import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_COMMS_SUMMARY, GET_COMMS_SUMMARY_ERROR, GET_COMMS_SUMMARY_SUCCESS } from '../../actions.js';

function* getCommsSummary({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/comms/summary`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_COMMS_SUMMARY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COMMS_SUMMARY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COMMS_SUMMARY_ERROR, payload: error });
  }
}

export function* watchGetCommsSummary() {
  yield takeEvery(GET_COMMS_SUMMARY, getCommsSummary);
}

function* getCommsSummarySaga() {
  yield all([fork(watchGetCommsSummary)]);
}

export default getCommsSummarySaga;
